import { useEffect, useState } from "react";

import { getStoredRepeatDonorEmail, getStoredRepeatDonorToken } from "../helpers/repeatDonorRecognition";

import { useAmplitude } from "./amplitude/useAmplitude";

export const useRepeatDonorRecognition = (): {
  repeatDonorToken: string | null;
  repeatDonorEmail: string | null;
  repeatDonorDeviceId: string | null;
} => {
  const [repeatDonorToken, setRepeatDonorToken] = useState<string | null>(null);
  const [repeatDonorEmail, setRepeatDonorEmail] = useState<string | null>(null);
  useEffect(() => {
    setRepeatDonorToken(getStoredRepeatDonorToken());
    setRepeatDonorEmail(getStoredRepeatDonorEmail());
  }, []);

  const { getAmplitudeDeviceId, isAmplitudeLoading } = useAmplitude();
  const [repeatDonorDeviceId, setRepeatDonorDeviceId] = useState<string | null>(null);
  useEffect(() => {
    if (!isAmplitudeLoading) {
      setRepeatDonorDeviceId(getAmplitudeDeviceId() ?? null);
    }
  }, [isAmplitudeLoading, getAmplitudeDeviceId]);

  return { repeatDonorToken, repeatDonorEmail, repeatDonorDeviceId };
};
